const translation = {
  tags: {
    business: 'Дело',
    videos: 'Видео',
    travel: 'Путешествовать',
    social: 'Общественный',
    agent: 'Агент',
    search: 'Искать',
    design: 'Проектировать',
    image: 'Образ',
    news: 'Новости',
    utilities: 'Коммунальные услуги',
    weather: 'Погода',
    medical: 'Медицинский',
    other: 'Другой',
    finance: 'Финансировать',
    education: 'Образование',
    productivity: 'Продуктивность',
    entertainment: 'Развлечение',
  },
  allTags: 'Все теги',
  searchTags: 'Поиск тегов',
}

export default translation
